<script lang="ts">
  import { locales } from '$lib/region/locales';
</script>

<svelte:head>
  {#each $locales as locale}
    <link rel="alternate" hreflang={locale?.hreflang} href={locale?.href} />
  {/each}
</svelte:head>
